import { FC } from 'react'
import { Component } from '../../types/ContentStructure'
import { SxProps } from '@mui/material';
import SectionFooter from './SectionFooter';
import ComponentLink from './ComponentLink';
import ComponentText from './ComponentText';
import ComponentForm from './ComponentForm';
import ComponentSection from './ComponentSection';
import ComponentBanner from './ComponentBanner';
import ComponentBannerText from './ComponentBannerText';
import ComponentCarrusel from './ComponentCarrusel';
import ComponentExternalNews from './ComponentExternalNews';
import ComponentFAQ from './ComponentFAQ';
import ComponentBenefitsAndRequirements from './ComponentBenefitsAndRequirements';
import ComponentImage from './ComponentImage';
import ComponentBannerTextLogo from './ComponentBannerTextLogo';
import ComponentLogo from './ComponentLogo';
import ComponentBannerProducto from './ComponentBannerProducto';
import ComponentBannerTextEmphasis from './ComponentBannerTextEmphasis';
import ComponentBannerEmphasis from './ComponentBannerEmphasis';
import ComponentIconosReguladores from './ComponentIconosReguladores';
import ComponentIconoItem from './ComponentIconoItem';

interface IComponentTypeProps {
    component: Component
    sx?: SxProps
}

const ComponentType: FC<IComponentTypeProps> = ({ component, sx = {} }) => {
    const { componentType, name, order } = component;
    try {
        switch (componentType.name) {
            case 'SECCION':
                return <ComponentSection component={component} sx={sx} />
            case 'TEXTO':
                return <ComponentText component={component} sx={sx} />
            case 'IMAGEN':
                return <ComponentImage component={component} sx={sx} />
            case 'FORMULARIO':
                return <ComponentForm component={component} />
            case 'BANNER':
                return <ComponentBanner component={component} />
            case 'BANNER TEXTO':
                return <ComponentBannerText component={component} />
            case 'BANNER TEXTO Y LOGO':
                return <ComponentBannerTextLogo component={component} sx={sx} />
            case 'BANNER TEXTO ÉNFASIS':
            // eslint-disable-next-line no-fallthrough
            case 'BANNER TEXTO ENFASIS':
                return <ComponentBannerTextEmphasis component={component} sx={sx} />
            case 'LINK':
                return <ComponentLink component={component} sx={sx} />
            case 'CARRUSEL':
                return <ComponentCarrusel component={component} />
            case 'NOTICIA EXTERNA':
                return <ComponentExternalNews component={component} />
            case 'FAQ':
                return <ComponentFAQ component={component} />
            case 'SECCION PADING':
                // BUG C3: tipo no mapeado — tratar igual que SECCION con padding cero
                return <ComponentSection component={component} sx={{ py: 0 }} />
            case 'BENEFICIOS Y REQUICITOS':
            // BUG C4: retrocompatibilidad — mantener ambos hasta migrar BD
            // eslint-disable-next-line no-fallthrough
            case 'BENEFICIOS Y REQUISITOS':
                return <ComponentBenefitsAndRequirements component={component} />
            case 'BANNER PRODUCTO':
                return <ComponentBannerProducto component={component} />
            case 'BANNER ENFASIS':
                return <ComponentBannerEmphasis component={component} />
            case 'LOGO':
                return <ComponentLogo component={component} sx={sx} />
            case 'ICONOS REGULADORES':
                return <ComponentIconosReguladores component={component} />
            case 'ICONO ITEM':
                return <ComponentIconoItem component={component} />
            case 'SECCION FOOTER':
                return <SectionFooter component={component} />
            default:
                return <p>Componente no soportado</p>
        }
    } catch (e) {
        console.log(e);
        return <p>Componente no soportado</p>
    }
}

export default ComponentType
